import { render, staticRenderFns } from "./MobileEmailDetails.vue?vue&type=template&id=3ce70db8&scoped=true&"
import script from "./MobileEmailDetails.vue?vue&type=script&lang=ts&"
export * from "./MobileEmailDetails.vue?vue&type=script&lang=ts&"
import style0 from "./MobileEmailDetails.vue?vue&type=style&index=0&id=3ce70db8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce70db8",
  null
  
)

export default component.exports